// src/components/Home/ActionCardsSection.tsx
import React, {useRef} from 'react';
import Button from '../Button';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import {motion, useInView} from "framer-motion";
import {useNavigate} from "react-router-dom";
import { trackEvent } from '../../../../lib/analytics';

interface CardProps {
    icon: React.ReactNode;
    title: string;
    description: string;
    index: number;
}


const ActionCard: React.FC<CardProps> = ({ icon, title, description, index  }) => {

const isMobile = useIsMobile();


    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    const navigate = useNavigate();

return (

    <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={isInView ? {opacity: 1, y: 0} : {}}
        transition={{duration: 0.5, delay: 0.4 + index * 0.2,  ease: 'easeOut', }}
        className="p-6 w-full gap-4 bg-white rounded-[16px] border-[1px] border-[#19CF7A1A] shadow-[0_4px_6px_0_rgba(0,0,0,0.1),_0_10px_15px_0_rgba(0,0,0,0.1)] min-h-[328px] md:min-h-[141px] transition-transform duration-300 hover:shadow-xl hover:-translate-y-1 flex flex-col  "
    >

            <div
                className="flex  justify-center items-center w-[64px] h-[64px] md:w-[48px] md:h-[48px] py-4 md:p-2 px-4 rounded-[12px] border-0 border-[#E5E7EB] bg-[#19CF7A1A]">
                <div>{icon}</div>
            </div>

            <div className={"flex flex-col gap-1"}>
                <h3 className="text-2xl md:text-base font-boldtext-[#111827]">{title}</h3>
                <p className="text-[#6C7B7F] text-base leading-[26px] md:leading-[23px] md:text-sm font-medium md:font-normal flex-grow">{description}</p>
            </div>


        <button

            onClick={() => {
                if (index === 1) {
                    navigate('/author');
                    setTimeout(() => window.scrollTo(0, 0), 100);

                } else if (index === 2) {
                    trackEvent('click_landing_cta', {
                        cta_name: 'book_story',
                        page_path: window.location.pathname,
                    });
                    navigate('/book');
                    setTimeout(() => window.scrollTo(0, 0), 100);

                } else if (index === 3) {
                    trackEvent('click_landing_cta', {
                        cta_name: 'postcard_book',
                        page_path: window.location.pathname,
                    });
                    navigate('/postcard');
                    setTimeout(() => window.scrollTo(0, 0), 100);

                }

            }}
            className={`flex flex-row gap-2 justify-center items-center text-base font-semibold md:text-sm self-start hover:underline transition-colors duration-200 ${
                index === 2 ? 'text-[#6C7B7F] hover:text-[#6C7B7F]' : 'text-green-500 hover:text-green-600'
            }`}
        >
                자세히 보기
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none" className={"md:w-3.5 md:h-3.5"}>
                    <g clip-path="url(#clip0_4962_10848)">
                        <path
                            d="M14.5656 8.70615C14.9563 8.31553 14.9563 7.68115 14.5656 7.29053L9.56563 2.29053C9.175 1.8999 8.54063 1.8999 8.15 2.29053C7.75938 2.68115 7.75938 3.31553 8.15 3.70615L11.4469 6.9999H1.85938C1.30625 6.9999 0.859375 7.44678 0.859375 7.9999C0.859375 8.55303 1.30625 8.9999 1.85938 8.9999H11.4438L8.15312 12.2937C7.7625 12.6843 7.7625 13.3187 8.15312 13.7093C8.54375 14.0999 9.17813 14.0999 9.56875 13.7093L14.5688 8.70928L14.5656 8.70615Z"
                            fill={index === 2 ? '#6C7B7F' : '#16B96A'}/>
                    </g>
                    <defs>
                        <clipPath id="clip0_4962_10848">
                            <path d="M0.859375 0H14.8594V16H0.859375V0Z" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
            </button>


    </motion.div>
);

}

const ActionCardsSection: React.FC = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, {once: true, margin: "-100px"});

    const isMobile = useIsMobile();



    return (


        <>

            <section className="py-[95px] px-4 md:px-8 flex flex-col gap-[64px] "
                     style={{
                         background: 'linear-gradient(90deg, #F5F8F6 0.07%, #F4FBF7 99.93%)'
                     }}
            >

                    <motion.div
                        ref={ref}
                        className="flex flex-col gap-3 text-center "
                        initial={{opacity: 0, y: 20}}
                        animate={isInView ? {opacity: 1, y: 0} : {}}
                        transition={{duration: 0.6, delay: 0}}
                    >
                        <h2 className="text-[36px] md:text-[20px] font-extrabold  text-[#111827]">
                            무엇을 할 수 있나요?
                        </h2>
                        <motion.span
                            ref={ref}
                            className="text-[24px] md:text-sm text-[#6C7B7F] md:leading-[22px] font-normal text-center"
                            initial={{opacity: 0, y: 20}}
                            animate={isInView ? { opacity: 1, y: 0 } : {}}
                        transition={{duration: 0.6, delay: 0.2}}
                    >
                        작가와 독자를 연결하는 다양한 기능들을 <br className="hidden md:block"/> 경험해 보세요.
                    </motion.span>
                </motion.div>

            <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6 md:grid-cols-1 ">
                <ActionCard
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none">
                            <g clipPath="url(#clip0_4962_10804)">
                                <path
                                    d="M10.5 12C12.0913 12 13.6174 11.3679 14.7426 10.2426C15.8679 9.11742 16.5 7.5913 16.5 6C16.5 4.4087 15.8679 2.88258 14.7426 1.75736C13.6174 0.632141 12.0913 0 10.5 0C8.9087 0 7.38258 0.632141 6.25736 1.75736C5.13214 2.88258 4.5 4.4087 4.5 6C4.5 7.5913 5.13214 9.11742 6.25736 10.2426C7.38258 11.3679 8.9087 12 10.5 12ZM8.35781 14.25C3.74063 14.25 0 17.9906 0 22.6078C0 23.3766 0.623438 24 1.39219 24H15.1312C14.9859 23.5875 14.9578 23.1375 15.0656 22.6969L15.7687 19.8797C15.9 19.35 16.1719 18.8719 16.5563 18.4875L18.4453 16.5984C16.9406 15.1453 14.8969 14.25 12.6375 14.25H8.35781ZM28.7719 11.0484C28.0406 10.3172 26.8547 10.3172 26.1188 11.0484L24.7406 12.4266L28.0687 15.7547L29.4469 14.3766C30.1781 13.6453 30.1781 12.4594 29.4469 11.7234L28.7719 11.0484ZM17.6203 19.5469C17.4281 19.7391 17.2922 19.9781 17.2266 20.2453L16.5234 23.0625C16.4578 23.3203 16.5328 23.5875 16.7203 23.775C16.9078 23.9625 17.175 24.0375 17.4328 23.9719L20.25 23.2687C20.5125 23.2031 20.7563 23.0672 20.9484 22.875L27.0047 16.8141L23.6766 13.4859L17.6203 19.5469Z"
                                    fill="#19CF7A"
                                    fillOpacity="0.2"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_4962_10804">
                                    <path d="M0 0H30V24H0V0Z" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
                    }
                    title="작가 소개"
                    description="독자에게 전하고 싶은 솔직 담백한 자기 소개와 출간작, 자주 쓰는 작품 유형 등을 소개해 보세요."
                    index={1}
                />
                <ActionCard
                    icon={<svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
                        <g clip-path="url(#clip0_4962_10821)">
                            <path d="M5.32812 0C2.84375 0 0.828125 2.01562 0.828125 4.5V19.5C0.828125 21.9844 2.84375 24 5.32812 24H18.8281H20.3281C21.1578 24 21.8281 23.3297 21.8281 22.5C21.8281 21.6703 21.1578 21 20.3281 21V18C21.1578 18 21.8281 17.3297 21.8281 16.5V1.5C21.8281 0.670312 21.1578 0 20.3281 0H18.8281H5.32812ZM5.32812 18H17.3281V21H5.32812C4.49844 21 3.82812 20.3297 3.82812 19.5C3.82812 18.6703 4.49844 18 5.32812 18ZM6.82812 6.75C6.82812 6.3375 7.16563 6 7.57812 6H16.5781C16.9906 6 17.3281 6.3375 17.3281 6.75C17.3281 7.1625 16.9906 7.5 16.5781 7.5H7.57812C7.16563 7.5 6.82812 7.1625 6.82812 6.75ZM7.57812 9H16.5781C16.9906 9 17.3281 9.3375 17.3281 9.75C17.3281 10.1625 16.9906 10.5 16.5781 10.5H7.57812C7.16563 10.5 6.82812 10.1625 6.82812 9.75C6.82812 9.3375 7.16563 9 7.57812 9Z" fill="#6C7B7F"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4962_10821">
                                <path d="M0.828125 0H21.8281V24H0.828125V0Z" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>}
                    title="출간작 알리기"
                    description="작품의 핵심 키워드와 출간 계기를 써보세요. 독자들에게 작품을 보는 새로운 관점을 제공할 수 있어요!"
                    index={2}

                />
                <ActionCard
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                            <g clip-path="url(#clip0_4962_10838)">
                                <path d="M0.65625 4.5C0.65625 2.84531 2.00156 1.5 3.65625 1.5H21.6562C23.3109 1.5 24.6562 2.84531 24.6562 4.5V19.5C24.6562 21.1547 23.3109 22.5 21.6562 22.5H3.65625C2.00156 22.5 0.65625 21.1547 0.65625 19.5V4.5ZM15.8344 9.49219C15.6234 9.18281 15.2766 9 14.9062 9C14.5359 9 14.1844 9.18281 13.9781 9.49219L9.9 15.4734L8.65781 13.9219C8.44219 13.6547 8.11875 13.5 7.78125 13.5C7.44375 13.5 7.11563 13.6547 6.90469 13.9219L3.90469 17.6719C3.63281 18.0094 3.58125 18.4734 3.76875 18.8625C3.95625 19.2516 4.35 19.5 4.78125 19.5H9.28125H10.7812H20.5312C20.9484 19.5 21.3328 19.2703 21.525 18.9C21.7172 18.5297 21.6937 18.0844 21.4594 17.7422L15.8344 9.49219ZM5.90625 9C6.50299 9 7.07528 8.76295 7.49724 8.34099C7.9192 7.91903 8.15625 7.34674 8.15625 6.75C8.15625 6.15326 7.9192 5.58097 7.49724 5.15901C7.07528 4.73705 6.50299 4.5 5.90625 4.5C5.30951 4.5 4.73722 4.73705 4.31526 5.15901C3.8933 5.58097 3.65625 6.15326 3.65625 6.75C3.65625 7.34674 3.8933 7.91903 4.31526 8.34099C4.73722 8.76295 5.30951 9 5.90625 9Z" fill="#16B96A"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_4962_10838">
                                    <path d="M0.65625 0H24.6562V24H0.65625V0Z" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    }
                    title="책과 관련된 엽서 홍보"
                    description="책과 함께 소개하고 싶은 엽서를 보여주세요. 책을 다 읽고도 남는 여운, 엽서로 독자와 이어가 보세요!"
                    index={3}
                />
            </div>
        </section>


        </>
    );
};

export default ActionCardsSection;
